import React from 'react';
import { useTranslation } from 'react-i18next';

const Footer = () => {
  const { t } = useTranslation();
  return (
    <footer className="w-full py-6 bg-white text-center text-gray-500 text-sm border-t mt-12">
      {t('footer.copyright')}
    </footer>
  );
};

export default Footer; 
